import React, { useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./components/Login";
import AiChat from "./components/AIChat";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import { Toaster } from "react-hot-toast";

function App() {
	const userData = sessionStorage.getItem("userData");
	const [userLogged, setUserLogged] = useState<boolean>(userData ? true : false);

	function checkWhenLogged(logged: boolean) {
		setUserLogged(logged);
	}
	return (
		<div className="App">
			<Toaster
				position="top-right"
				toastOptions={{
					success: {
						style: {
							background: "#fff", // Your custom teal
							color: "#00bfa5",
						},
					},
					error: {
						style: {
							background: "#fff", // Error red
							color: "#ff5252",
						},
					},
				}}
			/>
			{userLogged && <Navbar checkWhenLogged={checkWhenLogged} userLogged={userLogged} />}
			<Router>
				<Routes>
					<Route path="/login" element={userLogged ? <Navigate to="/" replace /> : <Login checkWhenLogged={checkWhenLogged} />} />
					<Route
						path="/"
						element={userLogged ? <AiChat checkWhenLogged={checkWhenLogged} /> : <Navigate to="/login" replace />}
					/>
				</Routes>
			</Router>
		</div>
	);
}

export default App;
